export const ROLE_KEYS = ['viewer', 'group-admin', 'super-admin'] as const;
export type RoleKey = (typeof ROLE_KEYS)[number];

export type KeyedRole = { id: string; key?: string | null };

export const roleRank = (key?: string | null) => ROLE_KEYS.indexOf(key as RoleKey);

export const assignableRoles = (roles: KeyedRole[], canAssignSuperAdmin: boolean) =>
  roles
    .filter((r) => roleRank(r.key) >= 0 && (canAssignSuperAdmin || r.key !== 'super-admin'))
    .sort((a, b) => roleRank(a.key) - roleRank(b.key));

export const viewerRoleId = (roles: KeyedRole[]) => roles.find((r) => r.key === 'viewer')?.id ?? '';
